<svg width="140" height="89" viewBox="0 0 140 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="graphic">
        <rect id="Rectangle 415" width="140" height="89" rx="4" fill="currentColor"/>
        <g id="Group 780">
            <rect id="Rectangle 422" x="9" y="41" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 424" x="34" y="41" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 426" x="59" y="41" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 428" x="84" y="41" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 430" x="109" y="41" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 423" x="9" y="55" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 432" x="9" y="69" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 425" x="34" y="55" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 433" x="34" y="69" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 427" x="59" y="55" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 434" x="59" y="69" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 429" x="84" y="55" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 435" x="84" y="69" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 431" x="109" y="55" width="23" height="12" rx="2" fill="#C1D1DF"/>
            <rect id="Rectangle 436" x="109" y="69" width="23" height="12" rx="2" fill="#C1D1DF"/>
        </g>
        <rect id="Rectangle 417" x="8" y="8" width="58" height="29" rx="2" fill="#C1D1DF"/>
        <rect id="Rectangle 418" x="74" y="8" width="58" height="29" rx="2" fill="#C1D1DF"/>
    </g>
</svg>
